import DefaultLayout from "../layouts/DefaultLayout";
import SortableDataTable from "../components/SortableDataTable";
import {useCallback, useEffect, useMemo, useState} from "react";
import CurrencyModal from "./modals/CurrencyModal";
import ConfirmationModal from "./modals/ConfirmationModal";
import useTranslation from "../hooks/translations";
import {DollarSign} from "react-feather";
import CurrencyService from "../services/CurrencyService";
import {useApi} from "../contexts/ApiProvider";
import ProtectedContent from "../components/ProtectedContent";

export default function CurrencySettingsPage() {
  const translations = useTranslation();
  const api = useApi()
  const currencyService = useMemo(() => new CurrencyService(api), [api]);
  const columns = [
    {
      name: translations.name,
      data_identifier: "name"
    },
    {
      name: translations.symbol,
      data_identifier: "symbol"
    }
  ];
  const pageTitle = translations.currency
  const pageSubtitle = translations.currencyPageSubtitle

  const [openCurrencyModal, setOpenCurrencyModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [rows, setRows] = useState([]);

  const getData = useCallback(async () => {
    const response = await currencyService.getAll();
    setRows(response.body);
  }, [currencyService]);

  const reorderData = useCallback(async (data) => {
    const formatedRequest = data.map((row) => {
      return {
        id: row.id,
        order: data.indexOf(row) + 1
      }
    });
    await currencyService.reorder(formatedRequest);
  }, [currencyService])

  useEffect(() => {
    (async () => {
      await getData()
    })();
  }, [getData]);

  // datatable callbacks
  const onEditClick = async (data) => {
    setSelectedRow(data)
    setOpenCurrencyModal(true)
  }

  const onDeleteClick = async (data) => {
    setSelectedRow(data)
    setOpenConfirmationModal(true)
  }

  const onAddClick = async () => {
    setOpenCurrencyModal(true)
    setSelectedRow({})
  }

  const handleDragEnd = async (data) => {
    setRows(data)
    await reorderData(data)
  }

  // currency modal callbacks
  const onModalSubmit = async (data) => {
    await getData()
    setOpenCurrencyModal(false)
  }

  const onModalClose = async () => {
    setOpenCurrencyModal(false)
  }

  // confirmation modal callbacks
  const onConfirmationModalSubmit = async (data) => {
    await currencyService.delete(data.id)
    await getData()
    setOpenConfirmationModal(false)
  }

  const onConfirmationModalClose = async () => {
    setOpenConfirmationModal(false)
  }

  return (
    <DefaultLayout icon={<DollarSign/>}
                   title={pageTitle}
                   subtitle={pageSubtitle}>
      <ProtectedContent
        allowedRoles={["Admin"]}
        alt={<div style={{textAlign: "center", margin: 10}}>
          <h1>{translations.permissionsAlert}</h1></div>}>
        <SortableDataTable title={pageTitle}
                           columns={columns}
                           rows={rows}
                           editAction={onEditClick}
                           deleteAction={onDeleteClick}
                           addAction={onAddClick}
                           dragEndAction={handleDragEnd}/>
        {openCurrencyModal &&
          <CurrencyModal data={selectedRow}
                         title={pageTitle}
                         onModalSubmit={onModalSubmit}
                         onModalClose={onModalClose}
                         showModal={openCurrencyModal}/>
        }
        {openConfirmationModal &&
          <ConfirmationModal data={selectedRow}
                             onConfirmationModalSubmit={onConfirmationModalSubmit}
                             onConfirmationModalClose={onConfirmationModalClose}
                             showModal={openConfirmationModal}/>
        }
      </ProtectedContent>
    </DefaultLayout>
  )
}
